import Checkbox from '../../../components/checkBox/CheckBox';
import Card from '../../../components/card/Card';
import P from '../../../components/texts/p/P';
import { useEffect, useState } from 'react';
import { useClientTheme } from '../../../context/ThemeContext';
import {
  getApplication,
  sendApplication,
  updateApplication,
} from '../../../services/ApplicationService';
import Modal from '../../../components/modal/modal';
import { Toast, useToast } from '../../../components/toast/toast';
import TextArea from '../../../components/textarea/TextArea';
import { APPLICATION_STATUS } from '../../../utils/Constants';
import { useNavigate, useParams } from 'react-router-dom';
import SummmaryPartners from './Partners';
import SummaryDocuments from './Documents';
import H from '../../../components/texts/h/H';
import Button from '../../../components/button/Button';
import Tooltip from '../../../components/tooltip/Tooltip';
import JSZip from 'jszip';
import {
  downloadClientDocument,
  downloadLufeCloudFile,
} from '../../../services/ClientService';
import { getMimeType } from '../../../utils/Utils';
import { legalEntities } from '../../../mocks/LegalEntities';
import { getOtherLegalEntitiesFileTypes } from '../../../services/ApplicationService';

import { hasData, isSuccessfulResponse } from '../../../utils/Utils';
import ActionButtonBar from '../../ActionButtonBar/ActionButtonBar';
import { routes } from '../../../routes/routePaths';
import SummaryAmounts from '../../common/SummaryAmounts';
import renderBasicData from '../../common/BasicData';
import { clientData } from '../../../types/interfaces';
interface SummaryProps {
  applicationStatus: number;
  onPreviousClick?: () => void;
  setClientData: Function;
  isSaving: boolean;
  clientData: clientData;
  onLoadClientData: Function;
  isClientDataLoaded: boolean;
  showButtons?: boolean;
  showPartners?: boolean;
  showSummaryDocuments?: boolean;
  showValidateComposition?: boolean;
  showSummaryApplication?: boolean;
  viewOnly?: boolean;
  hideDownloadButtons?: boolean;
}

const Summary: React.FC<SummaryProps> = ({
  applicationStatus,
  setClientData,
  onPreviousClick,
  isSaving,
  clientData,
  onLoadClientData,
  isClientDataLoaded,
  showButtons = true,
  showPartners = true,
  showSummaryDocuments = true,
  showValidateComposition = true,
  showSummaryApplication = true,
  viewOnly = false,
  hideDownloadButtons = false,
}) => {
  const [isRejectApplication, setIsRejectApplication] =
    useState<boolean>(false);
  const [isApproveApplicationOpen, setIsApproveApplication] =
    useState<boolean>(false);
  const [isSentApplicationOpen, setIsSentApplicationOpen] =
    useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('');
  const { cuit, id } = useParams();
  const navigate = useNavigate();
  const [isSendingApplication, setIsSendingApplication] =
    useState<boolean>(false);
  const [clientInfo, setClientInfo] = useState<clientData>(clientData);
  const [bulkDownloading, setBulkDownloading] = useState(false);
  const { clientTheme } = useClientTheme();
  const [otherLegalEntities, setOtherLegalEntities] = useState<Array<{id: number; code: string; description: string}>>([]);

  useEffect(() => {
    if (cuit && id && !isClientDataLoaded) {
      getApplication(cuit, id).then((response) => {
        if (hasData(response) && isSuccessfulResponse(response)) {
          setClientInfo(response.data);
          setClientData(response.data);
          onLoadClientData(true);
        }
      });
    } else {
      setClientInfo(clientData);
    }
  }, [cuit, id, isClientDataLoaded]);

  // Fetch de tipos de documentos al montar el componente
  useEffect(() => {
    const fetchOtherLegalEntities = async () => {
      try {
        const response = await getOtherLegalEntitiesFileTypes();
        if (response.success && response.data) {
          setOtherLegalEntities(response.data);
        }
      } catch (error) {
        console.error('Error fetching other legal entities:', error);
      }
    };

    fetchOtherLegalEntities();
  }, []);

  const getApplicationInfo = () => {
    return {
      products: clientInfo.products,
      manual_total_amount: clientInfo.manual_total_amount,
      requested_amount: clientInfo.requested_amount,
      reason: clientInfo.reason,
      review: clientInfo.review,
      extra_comments: clientInfo.extra_comments,
      has_valid_corporate_composition:
        clientInfo.has_valid_corporate_composition,
      corporate_structure: clientInfo.corporate_structure,
      signers: clientInfo.signers.map(signer => ({
        ...signer
      })),
      officer: clientInfo.officer,
      referrer_name: clientInfo.referrer_name,
      category_type_id: clientInfo.category_type_id,
      effective_date: clientInfo.effective_date,
      credit_type_id: clientInfo.credit_type_id,
    };
  };

  const handleSubmit = () => {
    setIsSendingApplication(true);
    sendApplication(clientInfo.cuit, getApplicationInfo(), id).then(
      (response) => {
        if (response.status === 201 || response.status === 200) {
          setIsSentApplicationOpen(true);
        } else if (response.status === 409 || response.status === 500) {
          useToast.error({
            title: 'Ya existe una solicitud existente para este cliente.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
        } else {
          useToast.error({
            title: 'Ocurrió un error inesperado. Intentá nuevamente.',
            id: 'application-toast',
            description: '',
            closeButton: false,
            autoClose: 5000,
          });
        }
        setIsSendingApplication(false);
      }
    ).catch((error) => {
      setIsSendingApplication(false);
    });
  };
  const handleApplication = (status: string) => {
    setIsSendingApplication(true);
    updateApplication(
      clientInfo.cuit,
      { status_code: status, comment: modalText },
      id
    ).then((response) => {
      const mapStatus = new Map();
      mapStatus.set(
        APPLICATION_STATUS.approved.label,
        'Aceptaste la documentación. El productor será notificado.'
      );
      mapStatus.set(
        APPLICATION_STATUS.rejected.label,
        'Declinaste la solicitud. El productor será notificado.'
      );
      mapStatus.set(
        APPLICATION_STATUS.pending.label,
        'Solicitaste cambios en la solicitud. El productor será notificado.'
      );

      if (isSuccessfulResponse(response)) {
        useToast.success({
          title: mapStatus.get(status),
          id: 'application-toast',
          description: '',
          closeButton: false,
          autoClose: 5000,
        });
        setTimeout(() => {
          navigate(routes.dashboard);
        }, 3000);
      }
      setIsSendingApplication(false);
    });
  };

  const renderApproveModal = () => {
    return (
      <Card>
        <P type='1' variant='neutral'>
          Al aceptar la documentación de la solicitud, esta pasará a análisis de
          riesgos.
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí un comentario sobre la documentación o dejalo en blanco.'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  const renderRejectModal = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Declinar una solicitud eliminará la documentación.
        </P>
        <P type='1' variant='danger' withMargin={false}>
          Esta acción no se puede deshacer
        </P>
        <P type='1' variant='neutral' withMargin={false}>
          También podés solicitar cambios. Detallalos abajo, y la solicitud
          volverá al productor con ese pedido.
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí los cambios que solicitás, o el motivo de la denegación.'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  const renderSentApplicationModal = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Enviaste la solicitud al comercial asignado. Te llegará una
          notificación cuando cambie de estado, y podrás visualizar la carpeta
          en tu dashboard.
        </P>
      </Card>
    );
  };

  const downloadFileToBlob = async (
    filename: string
  ): Promise<{ blob: Blob; filename: string } | null> => {
    try {
      if (!filename) {
        console.warn('No filename provided');
        return null;
      }

      let response;

      if (filename.includes('.')) {
        response = await downloadClientDocument(cuit || '', filename);

        if (!response.success && response.status === 500) {
          response = await downloadLufeCloudFile(
            cuit || '',
            filename.replace(/\.[^/.]+$/, '')
          );
        }

        if (response && response.success && response.data) {
          const mimeType = getMimeType(filename);

          if (response.data instanceof Blob) {
            return {
              blob: response.data,
              filename: filename,
            };
          } else {
            return {
              blob: new Blob([response.data], { type: mimeType }),
              filename: filename,
            };
          }
        }
      } else {
        response = await downloadLufeCloudFile(cuit || '', filename);
        if (response && response.success && response.data) {
          if (response.data instanceof Blob) {
            return {
              blob: response.data,
              filename: `${filename}.pdf`,
            };
          } else {
            return {
              blob: new Blob([response.data], { type: 'application/pdf' }),
              filename: `${filename}.pdf`,
            };
          }
        }
      }

      console.warn(`Failed to fetch file data for: ${filename}`, response);
      return null;
    } catch (error) {
      console.error(`Error downloading file to blob (${filename}):`, error);
      return null;
    }
  };

  const handleDownloadAll = async () => {
    const documents = clientInfo.files;
    const legalEntity = clientInfo.basic_data.legal_entity;

    const availableBasicDocs =
      legalEntities
        .find((item) => item.label === legalEntity)
        ?.requiredDocuments.filter(
          (document) =>
            documents.find((item) => item?.type === document.id)?.type &&
            documents.find((item) => item?.type === document.id)
              ?.is_basic_data
        )
        .map((document) => ({
          type: 'basic',
          title: document.value,
          filename: documents.find((item) => item?.type === document.id)
            ?.file_name,
        })) || [];

    const availableExtraDocs = documents
      .filter((doc) => !doc.is_basic_data && doc.file_name)
      .map((doc) => ({
        type: 'extra',
        title:
          otherLegalEntities.find((item) => item.code === doc.type)?.description ||
          'Documento Extra',
        filename: doc.file_name,
      }));

    const allDocs = [...availableBasicDocs, ...availableExtraDocs];
    const hasDocuments = allDocs.length > 0;

    if (!hasDocuments) {
      return;
    }

    setBulkDownloading(true);

    try {
      const zip = new JSZip();
      let successCount = 0;

      for (const doc of allDocs) {
        try {
          if (!doc.filename) continue;

          const fileData = await downloadFileToBlob(doc.filename);

          if (fileData) {
            const folderName =
              doc.type === 'basic'
                ? 'Documentacion_Basica'
                : 'Documentacion_Extra';
            const folder = zip.folder(folderName);
            if (folder) {
              folder.file(fileData.filename, fileData.blob);
              successCount++;
            }
          }
        } catch (fileError) {
          console.error('Error downloading file:', fileError);
        }

        await new Promise((resolve) => setTimeout(resolve, 300));
      }

      if (successCount === 0) {
        alert('No se pudo descargar ningún archivo. Por favor, inténtalo de nuevo.');
        return;
      }

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const timestamp = `${year}${month}${day}-${hour}${minute}`;
      const sanitizedCompanyName = (clientInfo.basic_data?.company_name && clientInfo.basic_data.company_name.trim())
        ? clientInfo.basic_data.company_name.replace(/[^a-zA-Z0-9\s]/g, '_').replace(/\s+/g, '_')
        : cuit || 'empresa';
      const zipFilename = `${sanitizedCompanyName}-comite-${timestamp}.zip`;

      const zipBlob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 6 },
      });

      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = zipFilename;
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error('Error creating ZIP:', error);
      alert('Error al crear el archivo ZIP. Por favor, inténtalo de nuevo.');
    } finally {
      setBulkDownloading(false);
    }
  };

  const renderProductsAndRequestAmount = (clientData: clientData) => {
    return (
      <Card margin={{ top: '4' }} width='100%'>
        <Card variant={clientTheme ? 'primary' : 'success'} modifier='weak' spacing={'2'}>
          <H
            type='3'
            variant='neutral-1'
            withMargin={false}
            weight='bold'
            modifier='strong'
          >
            Solicitud
          </H>
        </Card>
        <Card margin={{ top: '4' }} width='100%'>
          <SummaryAmounts
            clientData={clientData}
            isManualAmount={clientData.manual_total_amount}
            amounts={clientData.requested_amount}
            products={clientData.products}
            hideFianzaPagare={viewOnly}
          />
        </Card>
      </Card>
    );
  };

  return (
    <Card height='-webkit-fill-available' width='100%'>
      <Toast id='application-toast' />
      <Modal
        isOpen={isRejectApplication}
        onClose={() => setIsRejectApplication(false)}
        title={'Declinar o solicitar cambios'}
        primaryText='Solicitar cambios'
        primaryVariant='primary'
        secondaryText='Declinar solicitud'
        secondaryVariant='secondary'
        onSecondaryAction={() => {
          setIsRejectApplication(false);
          handleApplication(APPLICATION_STATUS.rejected.label);
        }}
        onPrimaryAction={() => {
          setIsRejectApplication(false);
          handleApplication(APPLICATION_STATUS.pending.label);
        }}
        children={renderRejectModal()}
      />
      <Modal
        isOpen={isApproveApplicationOpen}
        onClose={() => setIsApproveApplication(false)}
        title={'Aceptar documentación de solicitud'}
        primaryText='Aceptar documentación'
        primaryVariant='primary'
        secondaryText='Cancelar'
        secondaryVariant='secondary'
        onSecondaryAction={() => setIsApproveApplication(false)}
        onPrimaryAction={() => {
          setIsApproveApplication(false);
          handleApplication(APPLICATION_STATUS.approved.label);
        }}
        children={renderApproveModal()}
      />
      <Modal
        isOpen={isSentApplicationOpen}
        onClose={() => setIsSentApplicationOpen(false)}
        title={'Solicitud enviada'}
        primaryText='Ir al dashboard'
        primaryVariant='primary'
        secondaryText='Alta de nueva carpeta'
        secondaryVariant='secondary'
        onSecondaryAction={() => {
          setIsSentApplicationOpen(false);
          window.location.reload();
        }}
        onPrimaryAction={() => navigate(routes.dashboard)}
        children={renderSentApplicationModal()}
      />

      {renderBasicData(clientInfo)}
      {showValidateComposition && (
        <Card width='100%'>
          <Card variant={clientTheme ? 'primary' : 'success'} modifier='weak' spacing={'2'}>
            <H
              type='3'
              variant='neutral-1'
              withMargin={false}
              weight='bold'
              modifier='strong'
            >
              Socios
            </H>
          </Card>
          <Card
            display='flex'
            justifyContent='flex-end'
            gap='4px'
            margin={{ top: '2' }}
          >
            <Checkbox
              checked={clientInfo.has_valid_corporate_composition}
              disabled={true}
              id='summary_has_valid_corporate_composition-checkbox'
              size='md'
            >
              La información se ajusta a los documentos
            </Checkbox>
          </Card>
        </Card>
      )}
      {showPartners && (
        <SummmaryPartners
          partners={clientInfo.corporate_structure}
        ></SummmaryPartners>
      )}
      {showSummaryDocuments && (
        <Card margin={{ top: '4' }} width='100%'>
          <Card variant={clientTheme ? 'primary' : 'success'} modifier='weak' spacing={'2'} display='flex' justifyContent='space-between' alignItems='center' width='100%'>
            <H
              type='3'
              variant='neutral-1'
              withMargin={false}
              weight='bold'
              modifier='strong'
            >
              Documentación
            </H>
            {!hideDownloadButtons && (
              <Card>
                {(() => {
                  const documents = clientInfo.files;
                  const legalEntity = clientInfo.basic_data.legal_entity;
                  const hasDocuments =
                    documents.some(
                      (doc) =>
                        doc.is_basic_data &&
                        legalEntities
                          .find((item) => item.label === legalEntity)
                          ?.requiredDocuments.some((reqDoc) => reqDoc.id === doc.type)
                    ) || documents.some((doc) => !doc.is_basic_data);

                  return !hasDocuments ? (
                    <Tooltip
                      position='top'
                      showArrow={true}
                      msg='Esta solicitud no tiene archivos'
                    >
                      <Button
                        variant='primary'
                        size='md'
                        icon='download_outline'
                        iconAlign='left'
                        onClick={handleDownloadAll}
                        disabled={true}
                      >
                        Descargar todos
                      </Button>
                    </Tooltip>
                  ) : (
                    <Button
                      variant='primary'
                      size='md'
                      icon='download_outline'
                      iconAlign='left'
                      onClick={handleDownloadAll}
                      disabled={bulkDownloading}
                    >
                      {bulkDownloading ? 'Creando ZIP...' : 'Descargar todos'}
                    </Button>
                  );
                })()}
              </Card>
            )}
          </Card>
          <SummaryDocuments
            cuit={clientInfo.cuit}
            documents={clientInfo.files}
            legalEntity={clientInfo.basic_data.legal_entity}
            applicationId={id}
          />
        </Card>
      )}

      {showSummaryApplication && renderProductsAndRequestAmount(clientData)}

      {showButtons && (
        <ActionButtonBar
          applicationStatus={applicationStatus}
          isSaving={isSaving}
          onPreviousClick={onPreviousClick ? onPreviousClick : () => {}}
          handleSubmit={handleSubmit}
          isSendingApplication={isSendingApplication}
          navigate={navigate}
          setIsApproveApplication={setIsApproveApplication}
          setIsRejectApplication={setIsRejectApplication}
        />
      )}
    </Card>
  );
};

export default Summary;
